import React from 'react'
import classes from './style.module.scss'
import useStyles from 'isomorphic-style-loader/useStyles'
import Item from '../element'
import Checkbox from '../../../components/checkbox'
import SelectRecommend from './components/select-recommend'

export const SelectableItem = props => {
    useStyles(classes)
    const { item, soldout, editing, selectedItems, isGift, groupSort, itemSort } = props

    const clickHandle = e => {
        props.onSelect?.(item)
    }

    let selected

    if (editing) {
        selected = selectedItems?.some(i => i.id === item.id)
    } else {
        selected = item.selected
    }

    return <div className={classes.SelectableBox}>
        <div className={classes.SelectableItem}>
            <div className={`${classes.SelectArea}`} data-guide-select-button={groupSort === 1 && itemSort === 1}>
                <Checkbox disabled={soldout || isGift} onClick={clickHandle} selected={selected || isGift} />
            </div>
            <div className={classes.ItemArea}>
                <Item {...props} />
            </div>
        </div>
        {
            item?.recommend &&
            <div className={classes.SelectRecommendDiv}>
                <SelectRecommend products={item?.recommend?.products} msg={item?.recommend?.msg} productId={item?.productId}/>
            </div>
        }
    </div>
    
}

export default props => {
    useStyles(classes)
    const { items, onSelect, soldout, selectedItems, editing, itemDeleteHandle, itemChangeQtyHandle, addToWishList, itemChangeItemHandle, groupSort } = props
    return <div className={classes.Group}>
        {
            items?.map((item, index) => <SelectableItem itemSort={index+1} groupSort={groupSort} itemChangeItemHandle={itemChangeItemHandle} addToWishList={addToWishList} itemChangeQtyHandle={itemChangeQtyHandle} itemDeleteHandle={itemDeleteHandle} selectedItems={selectedItems} editing={editing} soldout={soldout} onSelect={onSelect} key={item.id} item={item} />)
        }
    </div>
}